import { render, staticRenderFns } from "./EditTopic.vue?vue&type=template&id=252f9a7d&"
import script from "./EditTopic.vue?vue&type=script&lang=js&"
export * from "./EditTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports